(function () {
  function wrapRoutineSections() {
    const main = document.querySelector('main.layout--template');
    if (!main) return;

    const sections = Array.from(main.children);
    const pairs = [];

    for (let i = 0; i < sections.length - 1; i++) {
      const current = sections[i];
      const next = sections[i + 1];

      if (
        current.classList.contains('section--shop-the-look') &&
        next.classList.contains('section--featured-text')
      ) {
        pairs.push([current, next]);
        i++; // on saute le suivant, car il est déjà pris
      }
    }

    pairs.forEach(([current, next]) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('routine-pair');

      main.insertBefore(wrapper, current);
      wrapper.appendChild(current);
      wrapper.appendChild(next);
    });
  }

  // 🔁 Attendre que tout soit bien chargé (utile sur Shopify)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapRoutineSections);
  } else {
    wrapRoutineSections();
  }

  // 🐌 Fallback : si le DOM est injecté plus tard (cas rare avec certains thèmes Shopify)
  window.addEventListener('load', () => {
    setTimeout(() => {
      wrapRoutineSections();
    }, 200); // léger délai pour laisser les sections se charger
  });
})();
